import {Component, Input, ChangeDetectionStrategy} from '@angular/core';


@Component({
    selector: 'motn-round-checkbox',
    styleUrls: ['./round-checkbox.component.scss'],
    templateUrl: './round-checkbox.component.html',
    imports: [],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RoundCheckboxComponent {
  @Input() label = '';
  @Input() isChecked = false;
}
